import classNames from 'classnames';
import { IconProps } from '.';

export const GrowthMagnifyingGlass = ({ className, color }: IconProps) => {
  const fill = color ?? 'var(--color-primary)';

  return (
    <svg
      className={classNames(className)}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.36'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3678 2.18662C11.0593 0.838039 9.2275 0 7.2 0C3.22355 0 0 3.22355 0 7.2C0 11.1764 3.22355 14.4 7.2 14.4C11.1764 14.4 14.4 11.1764 14.4 7.2C14.4 6.59924 14.3264 6.01567 14.1878 5.4578L12.5979 7.04769C12.5993 7.09829 12.6 7.14906 12.6 7.2C12.6 10.1823 10.1823 12.6 7.2 12.6C4.21766 12.6 1.8 10.1823 1.8 7.2C1.8 4.21766 4.21766 1.8 7.2 1.8C8.73044 1.8 10.1122 2.43667 11.0948 3.45961L12.3678 2.18662Z'
        fill={fill}
      />
      <path
        opacity='0.36'
        d='M17.4726 14.9273C18.1756 15.6302 18.1756 16.7697 17.4726 17.4726C16.7697 18.1756 15.6302 18.1756 14.9273 17.4726L12.2273 14.7726L14.7726 12.2273L17.4726 14.9273Z'
        fill={fill}
      />
      <path
        d='M17.1 3.6L15.9363 2.43633L8.99995 9.37266L6.29995 6.67266L4.23628 8.73633L2.96362 7.46367L6.29995 4.12734L8.99995 6.82734L14.6636 1.16367L13.5 0H17.1V3.6Z'
        fill={fill}
      />
    </svg>
  );
};
